import { useIsAuthenticated } from '@edge/spark/io-aws'
import { checkRoles, useIsGlobalAdmin, useRoles } from '@edge/spark/io-roles'
import React from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'

interface GuardedRouteProps extends RouteProps {
    requiredRoles?: string[]
    partialRoleList?: boolean
    requireGlobalAdmin?: boolean
}

export const GuardedRoute: React.VFC<GuardedRouteProps> = ({
    requiredRoles,
    partialRoleList,
    requireGlobalAdmin,
    ...routeProps
}: GuardedRouteProps) => {
    const isAuthenticated = useIsAuthenticated()
    const skip = !requiredRoles?.length || !isAuthenticated
    const roles = useRoles({ skip })
    const isEdgeAdmin = useIsGlobalAdmin()

    if (!isAuthenticated) {
        return <Redirect to="/login" />
    }

    if (requireGlobalAdmin && !isEdgeAdmin) {
        return <Redirect to="/login" />
    }

    if (!isEdgeAdmin && requiredRoles) {
        const foundRole = checkRoles(roles, requiredRoles, partialRoleList)

        if (!foundRole) {
            return <Redirect to="/" />
        }
    }

    return <Route {...routeProps}></Route>
}

export default GuardedRoute
